import { mergeStyles } from '@fluentui/react';
import { ComponentSlotStyle } from '@fluentui/react-northstar';

import { getBackgroundColor } from '../../Utils/Utils';

const messageAvatarContainerStyle = (avatar: string) =>
  mergeStyles({
    width: '2rem',
    minWidth: '2rem',
    height: '2rem',
    backgroundColor: getBackgroundColor(avatar)?.backgroundColor,
    borderRadius: '50%',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    fontFamily: 'Segoe UI Regular',
    fontSize: '1rem', // 16px
    float: 'left',
    marginRight: '5px'
  });

const chatContainerStyle = mergeStyles({
  height: '100%',
  width: '100%',
  maxHeight: '100%',
  // height: '500px',
  overflow: 'auto'
});

const noReadReceiptStyle = mergeStyles({
  width: '1rem'
});

const chatStyle: ComponentSlotStyle = {
  backgroundColor: 'white',
  border: 'none',
  overflow: 'auto',
  height: '100%',
  listStyleType: 'none',
  padding: '10px',
  fontSize: '16px'
};

const chatMessageStyle = (mine: boolean): ComponentSlotStyle => ({
  backgroundColor: mine ? 'rgba(42, 161,255, 0.25)' : 'rgba(243,242,241)',
  overflowY: 'hidden',
  borderRadius: '10px',
  // marginBottom: '5px',
  padding: '5px',
  flex: 1
});

const readReceiptIconStyle = (mine: boolean) =>
  mergeStyles({
    marginLeft: mine ? '5px' : '0rem',
    display: 'inline-block',
    alignSelf: 'flex-end',
    marginBottom: '6px'
  });

const newMessageButtonStyle = mergeStyles({
  float: 'right',
  width: 'fit-content'
});

const loadMoreMessageButtonStyle = mergeStyles({
  minHeight: '1.5rem'
});

const DownIconStyle = mergeStyles({
  marginRight: '0.5em'
});

const newMessageStaticStyle = mergeStyles({
  backgroundColor: 'rgba(42, 161, 255, 0.25)',
  padding: '5px',
  margin: '10px 10px 0 10px !important',
  borderRadius: '10px',
  fontSize: '16px'
});

const dropzone = mergeStyles({
  padding: '0px',
  border: 'dashed grey 4px',
  backgroundColor: 'rgba(255,255,255,.8)',
  color: '#bdbdbd',
  cursor: 'pointer',
  margin: '5px',
  height: '100%'
});

export {
  messageAvatarContainerStyle,
  chatMessageStyle,
  readReceiptIconStyle,
  chatContainerStyle,
  noReadReceiptStyle,
  chatStyle,
  newMessageButtonStyle,
  loadMoreMessageButtonStyle,
  DownIconStyle,
  newMessageStaticStyle,
  dropzone
};
